import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";

/**
 * Friendly offline fallback for data regions (issue #77).
 *
 * Screens swap their generic "couldn't load" error for this whenever a
 * fetch fails while the device is offline — a clear "you're offline"
 * signal instead of a broken/forever-spinner surface. The app shell
 * (nav, day picker) stays usable.
 */
export function OfflineErrorState() {
  const { t } = useTranslation();

  return (
    <div
      data-testid="offline-error"
      style={{
        padding: "var(--space-8) var(--space-4)",
        textAlign: "center",
        color: "var(--text-muted)",
      }}
    >
      <Icon name="compass" size={28} color="var(--text-faint)" />
      <div
        style={{
          font: "var(--fw-bold) var(--fs-lg)/1.2 var(--font-display)",
          color: "var(--text-strong)",
          marginTop: 10,
          marginBottom: 6,
        }}
      >
        {t("offline.errorTitle")}
      </div>
      <div style={{ font: "var(--fw-regular) var(--fs-sm)/1.5 var(--font-body)" }}>
        {t("offline.errorBody")}
      </div>
    </div>
  );
}
